import { render } from "./NewsAndUpdates.vue?vue&type=template&id=001e219e&ts=true"
import script from "./NewsAndUpdates.ts?vue&type=script&lang=ts&external"
export * from "./NewsAndUpdates.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__